import allRoutes from "@forento/core/routes"

const routes = allRoutes.app

export default routes
